import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Accounts, Home, Profile, Transfers } from "@assets";
import { Body } from "@components/Typography";
import { Routes } from "@ctypes";
import { useTheme, useWindowDimensions } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Intercom } from "@services";
import { TabBarItemContainer, TabContainer, TabContainerInner, useStyles } from "./styles";
import { TabBarItemProps, TabBarProps } from "./types";

export const TabBar = ({ showTab = false }: TabBarProps) => {
  const styles = useStyles();

  const navigate = useNavigate();

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width < 700) {
      Intercom.showLauncher();
    } else {
      Intercom.hideLauncher();
    }
  }, [width]);

  if (width >= 700 || !showTab) {
    return null;
  }

  return (
    <TabContainer>
      <TabContainerInner style={styles.inner}>
        <TabBarItem
          route={Routes.Dashboard}
          label={i18n.t(Translations.MainHeaderHomeTab)}
          onClick={() => navigate(Routes.Dashboard, { replace: true })}
        />
        <TabBarItem
          route={Routes.Accounts}
          label={i18n.t(Translations.MainHeaderAccountsTab)}
          onClick={() => navigate(Routes.Accounts, { replace: true })}
        />
        <TabBarItem
          route={Routes.Transfers}
          label={i18n.t(Translations.MainHeaderTransfersTab)}
          onClick={() => navigate(Routes.Transfers, { replace: true })}
        />
        <TabBarItem
          route={Routes.Profile}
          label={i18n.t(Translations.MainHeaderProfileTab)}
          onClick={() => navigate(Routes.Profile, { replace: true })}
        />
      </TabContainerInner>
    </TabContainer>
  );
};

export const TabBarItem = ({ route, label = "", onClick }: TabBarItemProps) => {
  const { theme } = useTheme();

  const { pathname } = useLocation();

  const selected = route === pathname;

  const fill = selected ? theme.tab.selected : theme.tab.default;

  const icon = (() => {
    switch (route) {
      case Routes.Dashboard:
        return <Home fill={fill} />;
      case Routes.Accounts:
        return <Accounts fill={fill} />;
      case Routes.Transfers:
        return <Transfers fill={fill} />;
      case Routes.Profile:
        return <Profile fill={fill} />;
      default:
        return null;
    }
  })();

  return (
    <TabBarItemContainer onClick={onClick}>
      {icon}
      <Body style={{ color: fill }}>{label}</Body>
    </TabBarItemContainer>
  );
};
